import React from 'react';
import Navbar from '../layout/Navbar';
import GroupWildernessTherapySection from './GroupWildernessTherapySection';
import ContactSection from '../home/ContactSection';
import Footer from '../layout/Footer';
import GlobalStyles from '../layout/GlobalStyles';

const GroupWildernessTherapyPage = () => {
  return (
    <>
      <GlobalStyles />
      <Navbar />
      <GroupWildernessTherapySection />
      <ContactSection />
      <Footer />
    </>
  );
};

export default GroupWildernessTherapyPage;